<template>

  <v-app-bar prominent theme="background" :elevation="1">

    <v-progress-linear color="cyan" indeterminate absolute bottom
      v-if="proxy.$store.state.commStore.serverCallCount"></v-progress-linear>

    <img :src="require('@/assets/images/Subtract.png')" @click.stop="onClick"
      style="width:32px; margin-left:27px; margin-top:20px; cursor: pointer;" v-show="drawer" />

    <template v-slot:append>

    </template>
    <v-spacer></v-spacer>

    <div class="model-settings-summary" role="status" aria-label="현재 채팅 설정">
      <span class="model-settings-summary__model" :title="selectedModelName">{{ selectedModelName }}</span>
      <div class="model-settings-summary__options">
        <span v-if="supportsTemperature" class="model-settings-summary__option" title="Temperature"
          :aria-label="`Temperature ${Number(temperatureSlider).toFixed(1)}`">
          <v-icon size="16" aria-hidden="true">mdi-thermometer</v-icon>
          {{ Number(temperatureSlider).toFixed(1) }}
        </span>
        <span v-if="deepThinkingEnabled" class="model-settings-summary__option model-settings-summary__option--active"
          title="깊은 사고 켜짐" role="img" aria-label="깊은 사고 켜짐">
          <v-icon size="16" aria-hidden="true">mdi-brain</v-icon>
        </span>
        <span v-if="deepThinkingEnabled && supportsReasoningEffort" class="model-settings-summary__option" title="Reasoning effort"
          :aria-label="`Reasoning effort ${reasoningEffort}`">{{ reasoningEffort }}</span>
      </div>
    </div>

    <v-menu v-model="menu" :close-on-content-click="false" location="end">
      <template v-slot:activator="{ props }">
        <v-btn color="indigo" v-bind="props" icon aria-label="채팅 설정">
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
      </template>

      <v-card width="500" class="model-settings-card">

        <v-list>
          <v-list-item>
            <v-select v-model="selectedModel" :items="modelChoices" item-title="name" item-value="value"
              label="사용 모델" density="compact" variant="outlined" hide-details
              :disabled="!modelsLoaded" class="my-2" />
          </v-list-item>
          <v-list-item v-if="modelLoadError">
            <v-alert type="error" density="compact" variant="tonal">모델 설정을 불러오지 못했습니다. 새로고침 후 다시 시도해주세요.</v-alert>
          </v-list-item>
          <v-list-item v-if="supportsTemperature" style="width:100%">
            <div style="display: flex; align-items: center; gap: 6px;">
              <div class="option-title">Temperature</div>
              <v-tooltip location="top" max-width="490" content-class="temperature-tooltip-bg">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" size="small" color="grey-lighten-1"
                    style="cursor: help;">mdi-help-circle-outline</v-icon>
                </template>
                <div class="temperature-tooltip">
                  <table class="temperature-tooltip__table">
                    <thead>
                      <tr>
                        <th>Temperature</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0.0 ~ 0.3</td>
                        <td>조회된 데이터를 바탕으로 내용에 최대한 충실한 답변을 제공합니다.<br />추측이나 불필요한 확장은 최소화됩니다.(DB 조회에 적당합니다.)</td>
                      </tr>
                      <tr>
                        <td>0.4 ~ 0.7</td>
                        <td>조회된 데이터를 바탕으로 핵심 내용은 유지하면서, 이해하기 쉽게 정리해 설명합니다.</td>
                      </tr>
                      <tr>
                        <td>0.8 ~ 1.0</td>
                        <td>조회된 데이터를 바탕으로 다양한 해석이나 표현이 추가될 수 있습니다. (문서 조회에 적당합니다. 다양성이 증가되어 답변이 매번 동일하지 않을 수 있습니다.)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-tooltip>
            </div>
            <v-slider v-model="temperatureSlider" :max="temperatureMax" :min="temperatureMin" step="0.1" class="align-center"
              style="width: 100" hide-details>
              <template v-slot:append>
                <v-text-field v-model="temperatureSlider" density="compact" style="width:88px" type="number"
                  hide-details single-line readonly></v-text-field>
              </template>
            </v-slider>
          </v-list-item>

            <v-list-item style="width:100%" v-if="supportsThinking">
              <v-switch v-model="isThink" color="primary" :disabled="thinkingRequired" >
                <template v-slot:label>
                  <div style="display: flex; align-items: center; gap: 6px;">
                    <span style="color: black;">깊은사고</span>
                    <v-tooltip location="top" content-class="help-tooltip-dark">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" size="small" color="grey-lighten-1"
                          style="cursor: help;">mdi-help-circle-outline</v-icon>
                      </template>
                      <span>더 다양한 정보를 탐색하고, 여러단계를 거처 검증하여 신뢰도 높은 답변을 생성합니다.(깊은사고는 많은 시간이 필요하며, 다양한 시도를 하기때문에 답변이 매번 동일하지 않을 수 있습니다.Temperature값은 0.9가 좋습니다.)</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-switch>
            </v-list-item>

            <v-list-item v-if="supportsReasoningEffort && deepThinkingEnabled">
              <v-select v-model="reasoningEffort" :items="reasoningEfforts" label="사고 수준"
                density="compact" variant="outlined" hide-details class="my-2" />
            </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <div v-if="selectedModelSettings?.provider === 'ollama'" style="padding-left: 8px; font-size: 14px; color: #9e9e9e; line-height: 1.4;">
            <div>범용: 문서,법률 조회에 적합합니다.</div>
            <div>코딩: 데이터베이스 조회에 적합합니다.</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="outlined" @click="menu = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

  </v-app-bar>

</template>

<script setup>

import { ref, computed, getCurrentInstance, onMounted, defineExpose, watch } from "vue";
import { getChatModel, setChatModel, loadModelSettings, getTemperature, getIsThink, getReasoningEffort, setReasoningEffort } from "@/utils/modelSettings";

// import jQuery from 'jquery';

// const $ = jQuery;
// window.$ = $;

const { proxy, emit } = getCurrentInstance();

const drawer = ref(false);

const menu = ref(false);

const selectedModel = ref(getChatModel());
const models = ref([]);
const modelsLoaded = ref(false);
const modelLoadError = ref(false);
const reasoningEffort = ref(getReasoningEffort());
const modelChoices = computed(() => models.value.map(model => ({
  ...model,
  name: ['gemini', 'openai'].includes(model.target) ? `${model.name} (유료)${model.available ? '' : ' · 설정 필요'}` : model.name,
  props: { disabled: !model.available }
})));
const selectedModelSettings = computed(() => models.value.find(model => model.value === selectedModel.value));

const temperatureMin = ref(0.0);
const temperatureMax = ref(1.0);
const temperatureSlider = ref(Number(getTemperature().toFixed(1)));

const savedThinking = ref(getIsThink());
const thinkingRequired = computed(() => selectedModelSettings.value?.thinkingRequired === true);
const supportsTemperature = computed(() => selectedModelSettings.value?.temperatureSupported !== false);
const isThink = computed({
  get: () => thinkingRequired.value || savedThinking.value,
  set: value => { savedThinking.value = value; localStorage.setItem('isThink', value); }
});

const reasoningEfforts = computed(() => selectedModelSettings.value?.reasoningEfforts || []);
const supportsReasoningEffort = computed(() => reasoningEfforts.value.length > 0);
const supportsThinking = computed(() => selectedModelSettings.value?.thinkingSupported === true);
watch(reasoningEffort, setReasoningEffort);

const selectedModelName = computed(() => selectedModelSettings.value?.name || '모델 설정 불러오는 중');

const deepThinkingEnabled = computed(() => isThink.value && supportsThinking.value);

const drawerUpdate = () => {
  drawer.value = !drawer.value;
};

const setDrawerState = (val) => {
  drawer.value = !val;
};

const onClick = () => {
  emit("setDrawer");
};


watch(temperatureSlider, () => {
  localStorage.setItem("temperature", temperatureSlider.value)
});
watch(selectedModel, () => {
  setChatModel(selectedModel.value);
  reasoningEffort.value = getReasoningEffort(selectedModel.value);
  setReasoningEffort(reasoningEffort.value);
  if (!modelsLoaded.value) return;
  if (selectedModelSettings.value?.provider !== 'ollama') return;
  const jsonObject = { model: selectedModel.value };

  // Unload other models in backend
  proxy.$axios.post("/chatting/models/unload-others", jsonObject)
    .then(response => {
      console.log("Unload success:", response.data);
    })
    .catch(err => {
      console.error("Unload error:", err);
    });

});


onMounted(async () => {
  try {
    const settings = await loadModelSettings(proxy.$axios);
    models.value = settings.models;
    selectedModel.value = getChatModel();
    reasoningEffort.value = getReasoningEffort(selectedModel.value);
    modelsLoaded.value = true;
  } catch (error) {
    console.error('모델 설정을 불러오지 못했습니다.', error);
    modelLoadError.value = true;
  }
})

defineExpose({
  //외부 컴포넌트에서 접근 가능한 객체 정의
  drawerUpdate,
  setDrawerState
})

</script>

<style scoped>
.model-settings-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 6px 12px;
  min-width: 0;
  margin: 0 12px;
  font-size: 13px;
  color: #475569;
}

.model-settings-summary__model {
  min-width: 0;
  max-width: 330px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  color: #334155;
}

.model-settings-summary__options {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 4px 6px;
}

.model-settings-summary__option {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  white-space: nowrap;
}

.model-settings-summary__option--active {
  background: #eef2ff;
  color: #4338ca;
}

.model-settings-card {
  max-width: calc(100vw - 24px);
  overflow-y: auto;
}

@media (max-width: 600px) {
  .model-settings-summary {
    flex: 1;
    gap: 4px;
    margin: 0 4px;
    font-size: 11px;
  }

  .model-settings-summary__model {
    max-width: 100%;
  }

  .model-settings-summary__option {
    padding: 2px 5px;
  }
}

.temperature-tooltip {
  padding: 2px 0;
}

.temperature-tooltip__table {
  border-collapse: collapse;
  font-size: 12px;
  font-weight: normal;
}

.temperature-tooltip__table th,
.temperature-tooltip__table td {
  padding: 4px 8px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.temperature-tooltip__table th {
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.35);
}

.temperature-tooltip__table tbody tr:last-child td {
  border-bottom: none;
}

/* number input 스피너 화살표 제거 */
:deep(input[type="number"]::-webkit-outer-spin-button),
:deep(input[type="number"]::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}
:deep(input[type="number"]) {
  -moz-appearance: textfield;
}
</style>

<style>
/* 툴팁 오버레이용 (content-class) - 흰 배경에서도 보이도록 */
.temperature-tooltip-bg,
.help-tooltip-dark {
  background: rgba(55, 65, 81, 0.96) !important;
  color: rgba(255, 255, 255, 0.92);
}
</style>
